/**
 * @todo Удалить файл
 * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
 * Не забудь удалить Marech.NewbuildingBuzzoolaIntegrationTestWeb.Enabled,
 * Marech.NewbuildingBuzzoolaIntegrationAsStub.Enabled и Marech.NewbuildingBuzzoolaFirst.Enabled из src/node/scheme.json
 * Если переходим на базуллу, то удаляем библиотеки адфокса @cian/adfox-component, @cian/adfox-templates, @cian/postview-analytics-utils
 * Если остаёмся на адфоксе, то удаляем библиотеку базуллы @cian/buzzoola-component
 */

import { useSelector } from 'react-redux';

import { selectExperiments } from 'shared/selectors/selectExperiments';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { isAbUseExperimentGroup } from 'shared/utils/experiments/isAbUseExperimentGroup';

export const NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB = 'newbuilding_buzzoola_integration_test_web';

export function useNewbuildingBuzzoolaIntegrationTestWebBuzzoolaGroup(): boolean {
  const experiments = useSelector(selectExperiments);

  const enabled = useNewbuildingBuzzoolaIntegrationTestWebExpEnabled();

  return enabled && isAbUseExperimentGroup(experiments, NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB, 'Buzzoola');
}

/**
 * @description Проверяет, включен ли фича-тоггл для эксперимента тестирования интеграции с базуллой
 */
export function useNewbuildingBuzzoolaIntegrationTestWebExpEnabled(): boolean {
  const { config } = useApplicationContext();

  return !!config.get<boolean>('Marech.NewbuildingBuzzoolaIntegrationTestWeb.Enabled');
}

/**
 * @description Проверяет, включен ли фича-тоггл для запроса базуллы при стабе адфокса
 */
export function useNewbuildingBuzzoolaIntegrationAsStubEnabled(): boolean {
  const { config } = useApplicationContext();

  return !!config.get<boolean>('Marech.NewbuildingBuzzoolaIntegrationAsStub.Enabled');
}

/**
 * @description Проверяет, включен ли фича-тоггл для запроса базуллы вместо адфокса
 */
export function useNewbuildingBuzzoolaFirstEnabled(): boolean {
  const { config } = useApplicationContext();

  return !!config.get<boolean>('Marech.NewbuildingBuzzoolaFirst.Enabled');
}
